/* eslint-disable no-console */
import { ChatContact } from '@src/types/chats';
import { removePhoneNumberPrefix } from '@src/utils/formatPhoneNumber';

// TODO: implement ContactPhoneError
//   if (!phoneNumber) throw new ContactPhoneError();
const getContactPhoneNumber = (contact: ChatContact) => {
  const phoneNumber = removePhoneNumberPrefix(
    contact.cmaId || contact.mobileNumber
  );
  //NOTE: temporary solution
  if (!phoneNumber) console.error('No phone number found for contact', contact);

  return phoneNumber;
};

export default getContactPhoneNumber;
